import { booleanAttribute, ChangeDetectionStrategy, Component, Inject, Input } from '@angular/core'
import { ENV, EnvRegistry } from '@app/env-registry'
import { PhonePipe } from '@features/phone-pipe/phone.pipe'

@Component({
    selector: 'app-contact-phone',
    templateUrl: './contact-phone.component.html',
    styleUrls: ['../styles.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [PhonePipe]
})
export class ContactPhoneComponent {

  @Input({ transform: booleanAttribute }) inheritColor = false

  @Input() linkText = ''

  readonly phoneNumber = this.env.contactUsNumber

  constructor(@Inject(ENV) private readonly env: EnvRegistry) {
  }
}
